<template>
  <div
    v-bind="$attrs"
    :class="$style['sliding-checkbox']">
    <input
      id="checkbox"
      :class="
        [$style['sliding-checkbox__input'],
         { [$style['sliding-checkbox__input--checked']]: props.checked }
        ]"
      type="checkbox">
    <label for="checkbox" :class="$style['sliding-checkbox__slider']">
      <SvgIcon
        v-if="checkedIcon"
        :name="checkedIcon"
        :class="$style['sliding-checkbox__checked-icon']" />
      <SvgIcon
        v-if="uncheckedIcon"
        :class="$style['sliding-checkbox__unchecked-icon']"
        :name="uncheckedIcon" />
    </label>
  </div>
</template>

<script setup>
const props = defineProps({
  checked: {
    type: Boolean,
    default: false
  },
  checkedIcon: {
    type: String,
    default: ''
  },
  uncheckedIcon: {
    type: String,
    default: ''
  }
})
</script>

<style module lang="scss">
.sliding-checkbox {
  position: relative;
  display: inline-block;
  width: $spacing * 7;
  height: $spacing * 4;

  &__input {
      opacity: 0;
      width: 0;
      height: 0;
    }

  &__slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: $grey-light;
    transition: 0.4s;
    border-radius: $spacing * 4;
  }

  &__checked-icon,
  &__unchecked-icon {
      width: $spacing * 2;
      height: $spacing * 2;
      fill: $white;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: $spacing;
      z-index: 1;
    }

    &__unchecked-icon {
      left: unset;
      right: $spacing;
      fill: $black;
    }

  &__slider::before {
    position: absolute;
    content: "";
    height: $spacing * 3;
    width: $spacing * 3;
    left: 4px;
    bottom: 4px;
    background-color: $white;
    transition: 0.4s;
    border-radius: 50%;
    z-index: 2;
  }

  &__input--checked + &__slider {
    background-color: $black;

    &::before {
      transform: translateX($spacing * 3);
    }
  }
}
</style>
